import { useCallback, useMemo } from 'react'

import { useQuery } from '@shared/modules/use-query/hooks'
import { UseQueryOptions } from '@shared/modules/use-query/types'

import { ProductCategoriesService } from '../services/categories'
import { ProductCategoryMappers } from '../mappers/categories'
import { ProductCategoryFormData } from '../types/categories'

export const useProductCategoryInitialValues = (id?: string) => {
  const initialValues = useMemo<ProductCategoryFormData>(() => ({ name: '', description: '' }), [])

  return useQuery(
    useCallback(async () => {
      const result = await ProductCategoriesService.getOneById(id || 0)

      if (result.status === 200) {
        return ProductCategoryMappers.formInitializer(result.data)
      } else {
        throw new Error(result.data)
      }
    }, [id]),
    useMemo<UseQueryOptions>(
      () => ({
        initialData: initialValues,
        enabled: !!id,
      }),
      [id, initialValues],
    ),
  )
}
